import { CR_SUBMISSION } from '../constants';
import { setSubmitButtonState } from '../helper/set-submit-button-state';

export type RemoveRatingErrorsParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const removeRatingErrors = ({ rootElement }: RemoveRatingErrorsParams) => {
    const hintSpan = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.HINT_SELECTOR);
    const titleSpan = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.TITLE_SELECTOR);
    const errorBanner = rootElement.querySelector<HTMLDivElement>(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_SELECTOR);
    errorBanner?.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
    hintSpan?.classList.remove(CR_SUBMISSION.STAR_RATING.HINT_INVALID_CLASS);
    titleSpan?.classList.remove(CR_SUBMISSION.STAR_RATING.TITLE_INVALID_CLASS);

    setSubmitButtonState({ rootElement, disabled: false, loading: false });
};
